document.addEventListener("DOMContentLoaded", function () {
    let timerStarted = false;
    let countdownInterval = null;
    let timerExpired = false;
    const TIMER_DURATION = 15 * 60;
    let timerElement = null;
    let expiredMessageElement = null;
    let countdownTextElement = null;

    function initializeElements() {
        timerElement = document.querySelector('#cart-timer-bar');
        expiredMessageElement = document.querySelector('#cart-timer-expired-message');
        countdownTextElement = document.querySelector('#cart-timer-countdown');

        if (!timerElement || !expiredMessageElement || !countdownTextElement) {
            console.error("⏱️ [TIMER] Timer elements not found on the page.");
            return false;
        }
        return true;
    }

    function startTimer(duration, remaining = null) {
        if (timerStarted || timerExpired) return;

        timerStarted = true;
        timerElement.style.display = 'flex';

        const startTime = Date.now();
        const timeLeft = remaining !== null ? remaining : duration;
        localStorage.setItem('cart_timer_start', startTime.toString());
        localStorage.setItem('cart_timer_duration', timeLeft.toString());

        let currentLeft = timeLeft;
        updateTimerText(currentLeft);

        countdownInterval = setInterval(() => {
            currentLeft--;
            updateTimerText(currentLeft);
            if (currentLeft <= 0) {
                clearInterval(countdownInterval);
                timerExpired = true;
                timerStarted = false;
                timerElement.style.display = 'none';
                expiredMessageElement.style.display = 'block';
                localStorage.removeItem('cart_timer_start');
                localStorage.removeItem('cart_timer_duration');
            }
        }, 1000);
    }

    function updateTimerText(seconds) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        countdownTextElement.textContent = `${minutes}:${secs.toString().padStart(2, '0')}`;
    }

    async function fetchCartAndProceed(callback) {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) throw new Error("Failed to fetch cart");
            const cart = await response.json();
            callback(cart);
        } catch (e) {
            console.error("⏱️ [TIMER] Error fetching cart:", e);
        }
    }

    function checkCartAndStartTimer() {
        fetchCartAndProceed(cart => {
            if (!cart) return;

            if (cart.item_count === 0) {
                clearInterval(countdownInterval);
                timerStarted = false;
                timerExpired = false;
                timerElement.style.display = 'none';
                expiredMessageElement.style.display = 'none';
                localStorage.removeItem('cart_timer_start');
                localStorage.removeItem('cart_timer_duration');
                return;
            }

            const storedStart = localStorage.getItem('cart_timer_start');
            const storedDuration = localStorage.getItem('cart_timer_duration');

            if (storedStart && storedDuration) {
                const elapsed = Math.floor((Date.now() - parseInt(storedStart)) / 1000);
                const remaining = parseInt(storedDuration) - elapsed;

                if (remaining <= 0) {
                    timerExpired = true;
                    timerStarted = false;
                    timerElement.style.display = 'none';
                    expiredMessageElement.style.display = 'block';
                } else if (!timerStarted && !timerExpired) {
                    startTimer(parseInt(storedDuration), remaining);
                }
            } else {
                startTimer(TIMER_DURATION);
            }
        });
    }

    const observer = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
            if (entry.name.includes('/cart')) {
                if (initializeElements()) {
                    checkCartAndStartTimer();
                }
            }
        }
    });

    observer.observe({ entryTypes: ['resource'] });

    if (initializeElements()) {
        checkCartAndStartTimer();
    }

    window.addEventListener('unload', () => {
        const navType = performance.getEntriesByType("navigation")[0]?.type;
        if (!navType || navType !== 'reload') {
            localStorage.removeItem('cart_timer_start');
            localStorage.removeItem('cart_timer_duration');
        }
    });
});
